export function tsTypeAssert<T> (value: T) {
    return value;
}